import { Button, Flex, Heading } from "@aws-amplify/ui-react";
import EmergencyContactFormItem from "./EmergencyContactFormItem";

export default function EmergencyContactFormContainer({
  control,
  append,
  remove,
  fields,
  onEmergencyContactDelete,
  errors,
  getValues,
  setValue
}) {
  return (
    <>
      <Flex direction="row" justifyContent="flex-start" alignItems="flex-start">
        <Heading level="4" children="Emergency Contacts"></Heading>
        <Button
          variation="primary"
          size="small"
          onClick={() => {
            append({ id: "", name: "", relationship: "", phone: "" });
          }}
        >
          Add
        </Button>
      </Flex>

      {fields.map((emergencyContact, index) => {

        return (
          <EmergencyContactFormItem
            key={`ec_${index}`}
            control={control}
            emergencyContact={emergencyContact}
            index={index}
            onEmergencyContactDelete={onEmergencyContactDelete}
            remove={remove}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
          />
        );
      })}
    </>
  );
}
